import { Component, Input } from '@angular/core';

/**
 * A component to accept a string and display an information icon that shows the string on hover
 */

@Component({
    selector: 'cl-hover-info',
    templateUrl: './HoverInfoView.html'
})
export class HoverInfoComponent {
    public static $name: string = 'clHoverInfo';

    /** A string of the text to display when hovering over the info icon */
    @Input() public hoverInfo: string;
}
